







































































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Logger } from 'aws-amplify';
import Users from "@/store/modules/Users";
import Viewpoints from "@/store/modules/Viewpoints";
import Dialogs from "@/store/modules/Dialogs";
import Decisions from "@/store/modules/Decisions";

const usersModule = getModule(Users);
const viewpointsModule = getModule(Viewpoints)
const decisionsModule = getModule(Decisions)
const dialogsModule = getModule(Dialogs);
// Logger.LOG_LEVEL = "DEBUG";
const logger = new Logger("ViewpointVisibilityDialog.vue");

@Component({
    components: {},
})
export default class ViewpointVisibilityDialog extends Vue {

    @Prop()
    viewpointId: string;

    private dialog = false;
    private submitting = false;

    private visibility = 'PRIVATE'
    private visibleUsers: string[] = [];

    get viewpoint() {
        if (viewpointsModule.decisionViewpointsMap) {
            return viewpointsModule.decisionViewpointsMap[this.viewpointId]
        }
    }

    get currentUserId() {
        if (usersModule.currentAuthUser) {
            return usersModule.currentAuthUser.username
        }
    }

    get decisionUsers() {
        return Object.values(decisionsModule.selectedDecisionUsers).filter(u => u.status === 'ACTIVE' && u.userId !== this.currentUserId)
    }

    @Watch('viewpointId')
    private onViewpointIdChange() {
        if (this.viewpointId && this.viewpoint) {
            this.visibility = this.viewpoint.visibility || 'PRIVATE'
            this.visibleUsers = this.viewpoint.visibleUsers || []
            this.dialog = true;
        } else {
            this.dialog = false;
        }
    }

    @Emit()
    private async save() {
        let viewpoint = JSON.parse(JSON.stringify(this.viewpoint))
        viewpoint.visibility = this.visibility;
        if (viewpoint.visibility === 'PRIVATE') {
            viewpoint.visibleUsers = this.visibleUsers
        } else {
            viewpoint.visibleUsers = null;
        }
        this.submitting = true;
        await decisionsModule.updateViewpoint(viewpoint)
        this.dialog = false;
        this.submitting = false;
    }


    @Emit()
    private close() {
        this.dialog = false;

    }

}
